import { render, staticRenderFns } from "./AccountEmailSend.vue?vue&type=template&id=10381e2c&scoped=true&"
import script from "./AccountEmailSend.vue?vue&type=script&lang=js&"
export * from "./AccountEmailSend.vue?vue&type=script&lang=js&"
import style0 from "./AccountEmailSend.vue?vue&type=style&index=0&id=10381e2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10381e2c",
  null
  
)


    import installComponents from "!/Users/dhulsman/Projects/rentmagic.website.vue.defietsambassadegent/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BContainer} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BContainer})
    

export default component.exports